// extracted by mini-css-extract-plugin
export default {"root":"MyJamSidebar_root__UpAsh","spacer":"MyJamSidebar_spacer__rHfPG"};